export const UPDATE_ORDERS_WIDGET = "UPDATE_ORDERS_WIDGET";